import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee61771"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "item mb-2" }
const _hoisted_3 = { class: "title-card" }
const _hoisted_4 = { class: "recipient-actions-row" }
const _hoisted_5 = { class: "recipient-item" }
const _hoisted_6 = { class: "recipient-dropdown" }
const _hoisted_7 = { class: "item mb-4" }
const _hoisted_8 = { class: "title-card" }
const _hoisted_9 = {
  key: 1,
  class: "bank-account-item"
}
const _hoisted_10 = { class: "title-card" }
const _hoisted_11 = {
  key: 1,
  class: "item mb-2"
}
const _hoisted_12 = { class: "section-card" }
const _hoisted_13 = {
  key: 0,
  class: "field account-action-row"
}
const _hoisted_14 = { class: "notification is-danger is-light is-size-6 account-type-warning" }
const _hoisted_15 = { class: "desync-title" }
const _hoisted_16 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_17 = { class: "is-size-7" }
const _hoisted_18 = { class: "desync-list is-size-7" }
const _hoisted_19 = { class: "has-text-right" }
const _hoisted_20 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_21 = { class: "is-size-7" }
const _hoisted_22 = { class: "desync-list is-size-7" }
const _hoisted_23 = { class: "field account-action-row" }
const _hoisted_24 = { class: "account-action-label" }
const _hoisted_25 = { class: "control account-action-control" }
const _hoisted_26 = {
  key: 1,
  class: "field account-action-row"
}
const _hoisted_27 = { class: "notification is-warning is-light is-size-6 account-type-warning" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "field account-action-row" }
const _hoisted_31 = { class: "account-action-label" }
const _hoisted_32 = { class: "is-flex is-align-items-center account-action-control" }
const _hoisted_33 = { class: "switch mr-2" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_36 = { class: "has-text-weight-medium" }
const _hoisted_37 = {
  key: 2,
  class: "field account-action-row account-action-column"
}
const _hoisted_38 = { class: "account-action-label barter-label" }
const _hoisted_39 = { class: "currency-limit-fields ml-4" }
const _hoisted_40 = { class: "field currency-limit-field" }
const _hoisted_41 = { class: "currency-limit-label" }
const _hoisted_42 = { class: "currency-limit-input" }
const _hoisted_43 = { class: "control has-suffix" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "input-suffix" }
const _hoisted_46 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_47 = { class: "field currency-limit-field" }
const _hoisted_48 = { class: "currency-limit-label" }
const _hoisted_49 = { class: "currency-limit-input" }
const _hoisted_50 = { class: "control has-suffix" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "input-suffix" }
const _hoisted_53 = {
  key: 0,
  class: "help is-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecipientItem = _resolveComponent("RecipientItem")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_loading = _resolveComponent("loading")!
  const _component_BankAccountItem = _resolveComponent("BankAccountItem")!
  const _component_DropdownButton = _resolveComponent("DropdownButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$gettext("General user account info")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RecipientItem, {
            recipient: _ctx.recipient,
            refreshToggle: _ctx.refreshToggle
          }, null, 8, ["recipient", "refreshToggle"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DropdownMenu, { object: _ctx.recipient }, null, 8, ["object"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$gettext("User account")), 1),
      (!_ctx.isUserAccountLoaded)
        ? (_openBlock(), _createBlock(_component_loading, {
            key: 0,
            active: true,
            "can-cancel": false,
            "is-full-page": false,
            class: "loader-container"
          }))
        : _createCommentVNode("", true),
      (_ctx.isUserAccountLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_BankAccountItem, {
              account: _ctx.userAccount,
              showSubAccounts: true,
              disableDropDown: false,
              isAccountSelected: true,
              refreshToggle: _ctx.refreshToggle,
              showInactiveAccountBalance: "true"
            }, {
              name: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userAccount.name ? _ctx.userAccount.name() : _ctx.$gettext("Unavailable")), 1)
              ]),
              _: 1
            }, 8, ["account", "refreshToggle"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$gettext("Account actions")), 1),
    (!_ctx.isAccountFormLoaded)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 0,
          active: true,
          "can-cancel": false,
          "is-full-page": false,
          class: "loader-container"
        }))
      : _createCommentVNode("", true),
    (_ctx.isAccountFormLoaded && Object.keys(_ctx.accountForm).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (_ctx.hasDesync)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Warning:")), 1),
                      _createTextVNode(_toDisplayString(" ") + " "),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$gettext("The administrative backend is not up to date.")), 1),
                      (_ctx.canFixDesync)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$gettext("Can be updated:")), 1),
                            _createElementVNode("ul", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixableDesyncFields, (d) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: d.field
                                }, _toDisplayString(d.field) + ": " + _toDisplayString(d.odooValue) + " → " + _toDisplayString(d.comchainValue), 1))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("button", {
                                class: "button is-danger is-outlined is-rounded sync-button",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFixDesync && _ctx.handleFixDesync(...args)))
                              }, _toDisplayString(_ctx.$gettext("Update")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.unfixableDesyncFields.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$gettext("Requires higher permissions:")), 1),
                            _createElementVNode("ul", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unfixableDesyncFields, (d) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: d.field
                                }, _toDisplayString(d.field) + ": " + _toDisplayString(d.odooValue) + " → " + _toDisplayString(d.comchainValue), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$gettext("Account type:")), 1),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.canChangeAccountType)
                    ? (_openBlock(), _createBlock(_component_DropdownButton, {
                        key: 0,
                        options: _ctx.accountTypeDropdownOptions,
                        modelValue: _ctx.accountForm.accountType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountForm.accountType) = $event))
                      }, null, 8, ["options", "modelValue"]))
                    : (_openBlock(), _createBlock(_component_DropdownButton, {
                        key: 1,
                        options: [
                  {
                    value: _ctx.accountForm.accountType,
                    label: _ctx.currentAccountTypeLabel,
                  },
                ],
                        modelValue: _ctx.accountForm.accountType,
                        disabled: true
                      }, null, 8, ["options", "modelValue"]))
                ])
              ]),
              (_ctx.accountTypeWarnings.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$gettext("Warning:")), 1),
                      _createTextVNode(_toDisplayString(" ") + " "),
                      (_ctx.accountTypeWarnings.includes('set-admin-irreversible'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$gettext(
                    "Setting an account to Admin is irreversible on this currency."
                  )), 1))
                        : _createCommentVNode("", true),
                      (_ctx.accountTypeWarnings.includes('set-admin-locks-limits'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$gettext(
                    "Admin accounts cannot have their credit limits modified."
                  )), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$gettext("Account status: ")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountForm.status) = $event)),
                      disabled: !_ctx.canChangeStatus
                    }, null, 8, _hoisted_34), [
                      [_vModelCheckbox, _ctx.accountForm.status]
                    ]),
                    _hoisted_35
                  ]),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.accountForm.status
                    ? _ctx.$gettext("Enabled")
                    : _ctx.$gettext("Disabled")), 1)
                ])
              ]),
              (_ctx.hasMutualCreditLimits)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$gettext("Mutual credit balance limits:")), 1),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$gettext("Maximum allowed")), 1),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["input", { 'is-danger': _ctx.negativeLimitError }]),
                              type: "text",
                              inputmode: "decimal",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountForm.highLimit) = $event)),
                              disabled: !_ctx.canChangeLimits,
                              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formatLimitField('highLimit')))
                            }, null, 42, _hoisted_44), [
                              [_vModelText, _ctx.accountForm.highLimit]
                            ]),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.userAccount.curr), 1)
                          ]),
                          (_ctx.negativeLimitError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.negativeLimitError), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$gettext("Minimum allowed")), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["input", { 'is-danger': _ctx.positiveLimitError }]),
                              type: "text",
                              inputmode: "decimal",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accountForm.lowLimit) = $event)),
                              disabled: !_ctx.canChangeLimits,
                              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formatLimitField('lowLimit')))
                            }, null, 42, _hoisted_51), [
                              [_vModelText, _ctx.accountForm.lowLimit]
                            ]),
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.userAccount.curr), 1)
                          ]),
                          (_ctx.positiveLimitError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.positiveLimitError), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}